<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MainPriceCell',
})
</script>
<template>
  <div :class="bem()">
    <span>{{ mainAmount }}</span>
    <Popover>
      <QuestionCircleOutlined :class="bem('icon')" />
      <template #content>
        <div :class="bem('content')">
          <div>
            砖混（现浇）结构：<b>{{ zhuanHunXianJiaoJieGouPrice }}</b>
          </div>
          <div>
            砖混（预制）结构：<b>{{ zhuanHunYuZhiJieGouPrice }}</b>
          </div>
          <div>
            砖木结构（土墙小青瓦）：<b>{{ zhuanMuJieGouXiaoQingWaPrice }}</b>
          </div>
          <div>
            土木、木结构（土墙小青瓦、砖墙草盖）：<b>{{ tuMuMuJieGouPrice }}</b>
          </div>
          <div>
            其他结构（土墙草盖、板房）：<b>{{ qiTaJieGouPrice }}</b>
          </div>
        </div>
      </template>
    </Popover>
  </div>
</template>

<script lang="ts" setup name="MainPriceCell">
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import { createNamespace } from '@bd/vue3-utils'
import { Popover } from 'ant-design-vue'
withDefaults(
  defineProps<{
    zhuanHunXianJiaoJieGouPrice?: number
    zhuanHunYuZhiJieGouPrice?: number
    zhuanMuJieGouXiaoQingWaPrice?: number
    tuMuMuJieGouPrice?: number
    qiTaJieGouPrice?: number
    mainAmount?: number
  }>(),
  {
    zhuanHunXianJiaoJieGouPrice: 0,
    zhuanHunYuZhiJieGouPrice: 0,
    zhuanMuJieGouXiaoQingWaPrice: 0,
    tuMuMuJieGouPrice: 0,
    qiTaJieGouPrice: 0,
    mainAmount: 0
  }
)
const [_, bem] = createNamespace('MainPriceCell')
</script>

<style lang="less">
.main-price-cell {
  &__icon {
    margin-left: @margin-xs;
    color: @gray;
  }

  &__content {
    width: 280px;

    div {
      display: flex;
      justify-content: space-between;
      padding: @padding-xs 0;
    }
  }
}
</style>
